import { type Stats, isAlive, educationLevel } from './stats.js';
import type { Job } from './job.js';

export const MONEY_SCORE_TARGET = 500_000;
export const DEATH_PENALTY = 0.5;

export const SCORE_WEIGHTS = Object.freeze({
  money: 1,
  education: 1,
  happiness: 1,
  job: 1,
});

export type ScoreBreakdown = {
  readonly money: number;
  readonly education: number;
  readonly happiness: number;
  readonly job: number;
  readonly total: number;
};

export function scoreBreakdown(stats: Stats, currentJob?: Job): ScoreBreakdown {
  const money = Math.max(0, (stats.money / MONEY_SCORE_TARGET) * 100);
  const education = educationLevel(stats.education) * 20;
  const happiness = Math.max(0, stats.happiness);
  const job = currentJob ? currentJob.scoreValue : 0;
  const raw =
    money * SCORE_WEIGHTS.money +
    education * SCORE_WEIGHTS.education +
    happiness * SCORE_WEIGHTS.happiness +
    job * SCORE_WEIGHTS.job;
  const total = isAlive(stats) ? raw : raw * DEATH_PENALTY;
  return Object.freeze({ money, education, happiness, job, total });
}

export function score(stats: Stats, currentJob?: Job): number {
  return scoreBreakdown(stats, currentJob).total;
}
